<template>
  <el-autocomplete
    v-model="textValue"
    v-loading="loading"
    :fetch-suggestions="querySearchAsync"
    :disabled="disabled"
    :debounce="1000"
    :clearable="true"
    size="small"
    value-key="load_point"
    placeholder="Поиск места загрузки"
    class="bids-autocomplete"
    popper-class="ttn-bids-popover"
    @select="handleSelect"
    @clear="onClear"
  >
    <template slot-scope="{ item }">
      <el-row>{{ getLoad(item) }}</el-row>
      <el-row>{{ getUnload(item) }}</el-row>
      <el-row>{{ item.org_name }}</el-row>
    </template>
  </el-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex'
import shippingMixin from '@/mixins/shippingMixin'

export default {
  name: 'BidsAutocomplete',
  mixins: [shippingMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Function,
      default: () => null,
    },
    text: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('hardware', ['ttnBids', 'getLoading']),
    loadingBids() {
      return this.getLoading('Bids')
    },
    textValue: {
      get() {
        return this.text
      },
      set(val) {
        this.$emit('set', val)
      },
    },
  },
  methods: {
    async querySearchAsync(queryString, cb) {
      if (queryString.length < 4) {
        cb([])

        return false
      }
      await this.search(this.text).then(() => cb(this.ttnBids))
    },
    getLoad(item) {
      return `${this.loadLocationFilter(item)}, ${
        item.load_point.split(',')[0]
      }`
    },
    getUnload(item) {
      return `${this.loadLocationFilter(item, 'unload_point')}, ${
        item.load_point.split(',')[1]
      }`
    },
    handleSelect(item) {
      this.$emit('selected', Number(item.id))
    },
    onClear() {
      this.$emit('selected')
    },
  },
}
</script>

<style lang="sass">
.bids-autocomplete
  width: 100%
.ttn-bids-popover
  li
    height: 100%
    line-height: 18px !important
    padding: 5px 20px
    border-bottom: 1px solid #393939
    &:last-child
      border-bottom: none
</style>
